import React, {useMemo} from 'react';
import PropTypes from 'prop-types';
import {Button, Space} from 'antd';
import {useTranslation} from 'react-i18next';
import {connect} from 'react-redux';
import {
  StyledExpenseDetailsTab,
  StyledExpenseDetailsTabFooter,
  StyledExpenseDetailsTabSpace,
  StyledExpenseDetailsTabPrice
} from './StyledExpenseDetailsTab';
import ExpenseDetails from '../tabComponents/ExpenseDetails';
import InvoiceDetailsPanel from '../../../TransactionsPage/InvoiceDetailsPanel/InvoiceDetailsPanel';
import {dateHelpers, expensesHelpers} from '../../../../../utils/helpers';
import {CheckIcon, CloseIcon} from '../../../../../icons';


const ExpenseDetailsTab = ({
  expense,
  onApprove,
  onEdit,
  onInvoiceRemove,
  onReject,
  onUpdate,

  dispatch,
  employeeEmail,
  isAdmin,
  ...rest
}) => {
  const [t] = useTranslation('main');

  const date = dateHelpers.getDateFromISO(expense?.created_at, 'DD MMM YYYY, HH:mm');

  const price = expensesHelpers.getExpensePrice(expense);

  const isApprovalAvailable = useMemo(() => {
    return expensesHelpers.isAvailableApproveActions({employeeEmail, expense, isAdmin});
  }, [isAdmin, employeeEmail, expense?.approval, expense?.review_status]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleAction = (e, action) => {
    const override = isAdmin && !expensesHelpers.isExpenseAlreadyApprovedByEmployee(expense, employeeEmail);
    action?.({e, expense, data: { admin_override: override }});
  };

  return (
    <StyledExpenseDetailsTab {...rest}>
      <StyledExpenseDetailsTabSpace direction='vertical' size='middle'>
        <Space size={4} direction='vertical'>
          <StyledExpenseDetailsTabPrice>{price}</StyledExpenseDetailsTabPrice>
          {date}
        </Space>
        <InvoiceDetailsPanel
          expense={expense}
          onExpenseUpdate={onUpdate}
          onInvoiceRemove={onInvoiceRemove}
        />
        <ExpenseDetails expense={expense} onEdit={onEdit} />
      </StyledExpenseDetailsTabSpace>

      {isApprovalAvailable && (
        <StyledExpenseDetailsTabFooter>
          <Button
            icon={<CloseIcon />}
            onClick={(e) => handleAction(e, onReject)}
            size='large'
          >
            {t('reject')}
          </Button>
          <Button
            icon={<CheckIcon />}
            onClick={(e) => handleAction(e, onApprove)}
            size='large'
            type='primary'
          >
            {t('approve')}
          </Button>
        </StyledExpenseDetailsTabFooter>
      )}

    </StyledExpenseDetailsTab>
  );
}

ExpenseDetailsTab.propTypes = {
  expense: PropTypes.object,
  onApprove: PropTypes.func,
  onEdit: PropTypes.func,
  onInvoiceRemove: PropTypes.func,
  onReject: PropTypes.func,
  onUpdate: PropTypes.func,
}

const mapStateToProps = ({ user }) => ({
  employeeEmail: user?.employee?.email,
  isAdmin: user.isAdmin,
});

export default connect(mapStateToProps, null)(ExpenseDetailsTab);
